import * as React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import ROUTERS from '../constans/router';

const  PrivateRoute = ({ isAuth }) => {
  const location = useLocation();
  let path = '?redirect=' + location.pathname + location.search;
  if (location.pathname === '/setting/change-password') {
    path = ''
  }else{
    path = '?redirect=' + location.pathname + location.search;
  }
  return <>{
    isAuth
    ? <Outlet /> 
    : <Navigate to={ROUTERS.LOGIN + path} />
  }</>;
};

export default PrivateRoute;
